import React, { useEffect } from 'react';
import UI from '../ui';
import Utils from '../utils';

const { Link } = UI;
const { Util } = Utils;

export const EndiciaRedirect = () => {
	const redirectToStamps = () => {
		Util.redirectEndiciaToStamps();
	};

	useEffect(() => {
		setTimeout(() => {
			redirectToStamps();
		}, 6000);
	}, []);

	return (
		<div className="common-redirect-container">
			<div className="content-wrapper">
				<div className="logo" />
				<p className="content-header">Redirecting you to Stamps.com</p>
				<p className="content-text">
					Endicia is merging with the Stamps.com brand. You are being redirected
					there now.
				</p>
				<p>
					If the page does not load after a few seconds,{' '}
					<Link dataqa="redirect_to_stamps_link" onClick={redirectToStamps}>
						click here
					</Link>
					.
				</p>
			</div>
		</div>
	);
};
